<template>
  <a-card size="small" type="inner">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">

        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>

        <a-col :span="6">
          <product-autocomplete route-name="report.product" style="width: 100%" @change="(item) => handleAutocomplete(item, 'products') "/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>
          <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" @click="handleDownload"
                    :style="{ display: expand ? 'inline-block' : 'none'}"/>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">
        <h5 slot="reconcileTime" slot-scope="time" class="text-center">
          {{ moment(time).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <h5 slot="transactionTime" slot-scope="time" class="text-center">
          {{ moment(time).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <div slot="transaction" slot-scope="record">
          <h4 class="copyable">{{ record.subscriber_id }} // <small>{{ record.product.name }}</small>
            <a-button size="small" type="link" @click="copy(record.subscriber_id)" icon="copy"/>
          </h4>
          <small v-if="record.ref_num !== null" class="copyable">
            # <code>{{ record.ref_num }}</code>
            <a-button size="small" type="link" @click="copy(record.ref_num)" icon="copy"/>
          </small>
          <small class="copyable">
            UUID: <code>{{ record.transaction_ref_id }}</code>
            <a-button size="small" type="link" @click="copy(record.transaction_ref_id)" icon="copy"/>
          </small>
        </div>

        <div slot="subscriber" slot-scope="record">
          <div>
            <h4>{{ record.subscriber_name }}</h4>
            <h5>
              - <code>Subscriber ID: {{ record.subscriber_id }}</code><br>
              - <code>Alternate ID: {{ record.alternate_id }}</code><br>
              - <code>SN: {{ record.ref_num }}</code><br>
            </h5>
          </div>
        </div>

        <h4 slot="adminFee" slot-scope="record" :style="{ color: '#2f2f2f'}">
          {{ currency(record.admin_fee) }}
        </h4>

        <h4 slot="shareFee" slot-scope="record" :style="{ color: '#2f2f2f'}">
          {{ currency(record.share_fee) }}
        </h4>

        <h4 slot="price" slot-scope="record" :style="{ color: record.price >= 0 ? '#237804' : '#a8071a'}">
          {{ currency(record.price) }}
        </h4>
      </a-table>
    </a-skeleton>
  </a-card>
</template>

<script>
const columns = [
  {
    dataIndex: 'reconcile_time',
    key: 'reconcile_time',
    title: 'Reconcile Time',
    width: 150,
    scopedSlots: {customRender: 'reconcileTime'}
  },
  {
    dataIndex: 'transaction_time',
    key: 'transaction_time',
    title: 'Transaction Time',
    width: 150,
    scopedSlots: {customRender: 'transactionTime'}
  },
  {
    key: 'transaction',
    title: 'Transaction',
    scopedSlots: {customRender: 'transaction'}
  },
  {
    key: 'subscriber',
    title: 'Subscriber',
    scopedSlots: {customRender: 'subscriber'}
  }, {
    key: 'admin_fee',
    title: 'Admin Fee',
    scopedSlots: {customRender: 'adminFee'}
  }, {
    key: 'share_fee',
    title: 'Fee',
    scopedSlots: {customRender: 'shareFee'}
  }, {
    key: 'price',
    title: 'Price',
    scopedSlots: {customRender: 'price'}
  }
];

export default {
  name: "report-reconciled-transaction-list",
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('report.transaction.reconciled')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('report.transaction.reconciled.export') + '?' + this.$qs.stringify(params)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      modal: {
        visible: false,
        item: {}
      },
      filters: {
        page: 1,
        per_page: 10,
        date: [],
        products: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        page: 1,
        per_page: 10,
        q: '',
        products: [],
        service: [],
        status: [],
        date: []
      }
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    handleDownload() {
      window.open(this.exportUri, '_blank')
    }
  }
}
</script>

<style scoped>

</style>
